import { BrandMark, Avatar } from "./BrandMark";
import { updatedLabel } from "@/lib/time";
import { Link } from "react-router-dom";
import { TemplateInfoPopover } from "./TemplateInfoPopover";

function statusPill(t) {
    if (t.draft)
        return <span className="tms-chip status-draft" data-testid={`status-draft-${t.id}`}>Draft</span>;
    if (t.shared)
        return <span className="tms-chip status-shared" data-testid={`status-shared-${t.id}`}>Shared</span>;
    return <span className="tms-chip status-private" data-testid={`status-private-${t.id}`}>Private</span>;
}

function ownerLabel(t, meId) {
    return t.owner_id === meId ? "You" : t.owner?.name || "—";
}

export function TemplateCard({ template, brand, meId, selectable = false, selected = false, onToggleSelected }) {
    const brandCode = brand?.short_code || template.brand_key.toUpperCase();
    const subjectClean = (template.subject || "").replace(/<[^>]+>/g, "");
    const description = (template.description || "").trim();
    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onToggleSelected && onToggleSelected();
    };
    return (
        <div style={{ position: "relative" }}>
            {selectable && (
                <label
                    onClick={handleCheckboxClick}
                    data-testid={`template-select-${template.id}`}
                    aria-checked={selected}
                    role="checkbox"
                    className="template-select"
                    style={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        zIndex: 3,
                        width: 22,
                        height: 22,
                        borderRadius: 6,
                        border: `1.5px solid ${selected ? "var(--tms-green)" : "var(--tms-border)"}`,
                        background: selected ? "var(--tms-green)" : "rgba(255,255,255,0.85)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        opacity: selected ? 1 : 0.55,
                        transition: "opacity 120ms, background 120ms",
                    }}
                >
                    {selected && (
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    )}
                </label>
            )}
            <Link
                to={`/templates/${template.id}`}
                data-testid={`template-card-${template.id}`}
                className={`tms-card tms-shadow-lift p-5 flex flex-col gap-3 no-underline text-left${selected ? " template-card-selected" : ""}`}
                style={{
                    color: "var(--tms-text)",
                    outline: selected ? "2px solid var(--tms-green)" : "none",
                    outlineOffset: -1,
                }}
            >
                <div className="flex items-center justify-between">
                    <BrandMark brand={brand} code={brandCode} size="sm" />
                    {statusPill(template)}
                </div>
                <div>
                    <div className="cat-chip mb-1">{template.category}</div>
                    <div className="flex items-start gap-1.5" style={{ gap: 6 }}>
                        <div style={{ fontSize: 16, fontWeight: 600, color: "var(--tms-navy)", lineHeight: 1.3, flex: 1, minWidth: 0 }}>
                            {template.name}
                        </div>
                        <div
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                            style={{ marginTop: 2 }}
                        >
                            <TemplateInfoPopover template={template} testIdSuffix={template.id} />
                        </div>
                    </div>
                    <div
                        style={{
                            marginTop: 6,
                            fontSize: 13,
                            color: "var(--tms-muted)",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                        }}
                    >
                        {subjectClean}
                    </div>
                    {description && (
                        <div
                            data-testid={`template-card-desc-${template.id}`}
                            style={{
                                marginTop: 6,
                                fontSize: 12,
                                color: "var(--tms-faint)",
                                fontStyle: "italic",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                            title={description}
                        >
                            {description}
                        </div>
                    )}
                </div>
                <div className="flex items-center justify-between mt-auto pt-2 border-t" style={{ borderColor: "var(--tms-border)" }}>
                    <div className="flex items-center gap-2">
                        <Avatar initials={template.owner?.initials} name={template.owner?.name} size="sm" />
                        <span style={{ fontSize: 12, color: "var(--tms-muted)" }}>{ownerLabel(template, meId)}</span>
                    </div>
                    <span style={{ fontSize: 11, color: "var(--tms-faint)" }}>{updatedLabel(template)}</span>
                </div>
            </Link>
        </div>
    );
}
